import { forwardRef, useImperativeHandle, useState } from "react";
import styles from "./YoutubeVideoOverlay.module.css";
import { MdClose } from "react-icons/md";

const YoutubeVideoOverlay = forwardRef(({ videoLink }, ref) => {
  const [showVideo, setShowVideo] = useState(false);

  const openVideo = () => {
    setShowVideo(true);
  };

  const closeVideo = () => {
    setShowVideo(false);
  };

  useImperativeHandle(ref, () => {
    return { openVideo };
  });

  return (
    showVideo && (
      <div className={styles.videoOverlay}>
        <button className={styles.closeBtn} onClick={closeVideo}>
          <MdClose />
        </button>
        <iframe
          src={`${videoLink}?autoplay=1`}
          allow="autoplay; encrypted-media"
          allowFullScreen
          title="Intro Video"
        />
      </div>
    )
  );
});

export default YoutubeVideoOverlay;
